import { useQuery } from '@tanstack/react-query';
import { getPropertyServiceTotals } from '../api/service';
import { IPropertyServiceTotalParams } from '../interfaces/service';

export const usePropertyServiceTotals = (params: IPropertyServiceTotalParams) => {
    return useQuery({
        queryFn: () => getPropertyServiceTotals(params),
        queryKey: ['portal', 'service', 'totals', params.ResourceProfileCompleted]
    });
};